function InfinitProgressBar() {
    return (
        <div class="demo-container">
            <div class="progress-bar">
                <div class="progress-bar-value"></div>
            </div>
        </div>
    )
}

export default InfinitProgressBar;